export const RESOURCE_TYPE_FILTERS_DIRECTORY = 'FILTERS_DIRECTORY';
